import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SITE_BASE = "https://alukola-bazar.cz";
const DEFAULT_DESC =
  "Originální alu kola, pneumatiky, pokličky a autodíly pro Audi, VW, BMW, Mercedes-Benz, Škoda, Porsche a další. Vše skladem, rozvoz po Praze. M + J s.r.o., od roku 2002.";
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1607908181896-65d5f06fd6c4?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200";
const DEFAULT_TITLE = "alukola-bazar | Alu kola, pneumatiky a autodíly";

// Jediná SEO komponenta na stránku – zajišťuje přesně jednu sadu meta tagů
// (title, description, canonical, Open Graph, Twitter) bez duplicit.
export default function Seo({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  type = "website",
  noIndex = false,
}) {
  const { pathname } = useLocation();
  const canonical = `${SITE_BASE}${pathname}`;
  const fullTitle = title ? `${title} | alukola-bazar` : DEFAULT_TITLE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
